/*globals $:false */

import DiagramDefinitionsBuilder from "../helpers/diagram.definitions.builder.js";
import DefinitionsDiagramV from "../view/recordm.view.domaindefinitions.diagram";
import DefinitionM from '../model/recordm.model.entity.definition.js';
import DefinitionsV from '../view/recordm.view.domaindefinitions.definitions.js';
import DomainM from '../model/recordm.model.entity.domain.js';
import DomainsDefinitionsFilterV from "../view/recordm.view.domaindefinitions.filter";
import DomainsV from '../view/recordm.view.domaindefinitions.domain.js';
import FieldErrorM from '../helpers/model.def-field-error.js';
import FileUpload from '@cob/ui-genesis/helpers/cob.file-upload.js';
import UriBuilder from '../helpers/module.uribuilder.js';

import utils from '@cob/ui-genesis/cob.utils.js';

var DomainDefinitionsP = function(core, $container) {

    var _domainsM = [],
        _definitionsM = [];

    let _filter;
    let _filteredDefinitions = [];

    var _loadingKey = core.getLoadingKey();

    const diagramBuilder = new DiagramDefinitionsBuilder(core)

    var uploadFileP = new FileUpload.UploadFileP(core,
        {
            uploadSuccessful: function(fileName, data) {
                var definition = JSON.parse(data.result);

                _onDefinitionAdded(undefined, definition);
            },
            uploadFailed: function(fileName, data) {
                var requestCode = data.jqXHR.status,
                    errors = _getErrorMsgs(requestCode, data.jqXHR.responseText);

                uploadFileP.showErrors(errors);
            }
        },
        {
            closeOnFail:false,
            allowedFileExtensions:["json"],
            dialogTitle: core.translateString('recordm.domains', 'definitions.actions.import')
        }
    );

    const relevant = function(def, filter) {
        return !filter || filter
            .split(" ")
            .every((filterPart) => {
                let simplifiedFilterPart = _simplify(filterPart);

                const simplifiedDefName = _simplify(def.getName())
                const simplifiedDefDescription = _simplify(def.getDescription())

                if (simplifiedFilterPart.startsWith("-")) {
                    simplifiedFilterPart = simplifiedFilterPart.substring(1)
                    if (simplifiedFilterPart?.trim().length === 0) return true

                    return def.getId() !== simplifiedFilterPart
                           && !simplifiedDefName.includes(simplifiedFilterPart)
                           && !simplifiedDefDescription?.includes(simplifiedFilterPart)
                } else {
                    return def.getId() === simplifiedFilterPart
                           || simplifiedDefName.includes(simplifiedFilterPart)
                           || simplifiedDefDescription?.includes(simplifiedFilterPart)
                }
            })
    }

    const _filterDomains = function (filterStr) {
        let filteredDomains = _domainsM;

        if(filterStr && filterStr.trim().length > 0){
            filterStr.split(" ").forEach((subFilter) => {
                const simplified = _simplify(subFilter);

                filteredDomains = filteredDomains.filter(function(domain){
                    return _simplify(domain.getName()).includes(simplified)
                        || _simplify(domain.getDescription()).includes(simplified)
                        || domain.getId() === simplified
                });
            });
        }

        filteredDomains.sort(DomainM.compareNames);

        domainsV.showDomains(filteredDomains);
    }

    const _filterDefinitions = function(filterStr) {
        const filteredDefs = _definitionsM.filter((def) => relevant(def, filterStr))
        filteredDefs.sort(DefinitionM.sortByNameAndStateFn);

        _filteredDefinitions = filteredDefs
        definitionsV.showDefinitions(filteredDefs);
    }

    // lowercase and remove diacritics (accents)
    // from https://stackoverflow.com/a/37511463
    const _simplify = (str) => str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const _updateModuleUrlFilters = function(filterStr){
        let newUrl = `/domains`;

        if(filterStr !== undefined){
            newUrl += `/filter=${filterStr}`;
        }

        core.changeRouteWithoutNavigation(newUrl);
    }

    const filterV = new DomainsDefinitionsFilterV(core, $container, {
        filter: function (filterStr){
            _filter = filterStr;
            _filterDomains(filterStr);
            _filterDefinitions(filterStr);

            _updateModuleUrlFilters(filterStr);
        }
    });

    const domainsV = new DomainsV(core, $container, {
            getDomain: function(domainId) {
                return _getEntityMFrom(domainId, _domainsM).data;
            },
            createDomain: function(name) {
                core.showLoading(_loadingKey, "_domainsM.createDomain");

                var domainM = new DomainM(core),
                    data = {"name": name},
                    errors = domainM.validate(data);

                if (errors.size > 0) {
                    domainsV.showCreateDomainErrors(errors);
                    core.hideLoading(_loadingKey, "_domainsM.createDomain");

                } else {
                    domainM.sync(data, {
                        fieldError: function(errors) {
                            domainsV.showCreateDomainErrors(errors);
                            core.hideLoading(_loadingKey, "_domainsM.createDomain");
                        }
                    });
                }
            },
            updateDomain: function(domainData) {
                core.showLoading(_loadingKey, "_domainsM.updateDomain");

                var domainM = _getEntityMFrom(domainData.id, _domainsM),
                    errors = domainM.validate(domainData);

                if (errors.size > 0) {
                    domainsV.showCreateDomainErrors(errors);
                    core.hideLoading(_loadingKey, "_domainsM.domainUpdated");

                } else {
                    domainM.sync(domainData, {
                        fieldError: function(errors) {
                            domainsV.showCreateDomainErrors(errors);
                            core.hideLoading(_loadingKey, "_domainsM.domainUpdated");
                        }
                    });
                }
            },
            deleteDomain: function(domainId) {
                core.showLoading(_loadingKey, "_domainsM.deleteDomain");
                _getEntityMFrom(domainId, _domainsM).deleteSelf();
            },
            removeDefinitionFromDomain: function(domainId, definitionId) {
                core.showLoading(_loadingKey, "_domainsM.removeDefinitionFromDomain");
                _getEntityMFrom(domainId, _domainsM).removeDefinitionFromDomain(definitionId);
            },
            addDefinitionToDomain: function(domainId, definitionId) {
                core.showLoading(_loadingKey, "_domainsM.addDefinitionToDomain");
                _getEntityMFrom(domainId, _domainsM).addDefinitionToDomain(definitionId);
            }
        }
    );

    const definitionsV = new DefinitionsV(core, $container, {
            getDefinition: function(definitionId) {
                return _getEntityMFrom(definitionId, _definitionsM).data;

            },
            indexDefinition: function(definitionId, recreate) {
                return _getEntityMFrom(definitionId, _definitionsM).index(recreate);

            },
            upgradeInstances: function(definitionId) {
                return _getEntityMFrom(definitionId, _definitionsM).upgradeInstances();

            },
            cloneDefinition: function(definitionId) {
                core.showLoading(_loadingKey, "_definitionM.cloneDefinition");
                _getEntityMFrom(definitionId, _definitionsM).clone();

            },
            disableDefinition: function(definitionId) {
                core.showLoading(_loadingKey, "_definitionM.disableDefinition");
                _getEntityMFrom(definitionId, _definitionsM).disable();

            },
            enableDefinition: function(definitionId) {
                core.showLoading(_loadingKey, "_definitionM.enableDefinition");
                _getEntityMFrom(definitionId, _definitionsM).enable();

            },
            deleteDefinition: function(definitionId) {
                core.showLoading(_loadingKey, "_definitionM.deleteDefinition");
                _getEntityMFrom(definitionId, _definitionsM).deleteSelf();

            },
            generateDiagram: function() {
                const visibleDefs = _filteredDefinitions || _definitionsM
                const defsWithFields = []

                const initialConfs = {showReferences: false, showLabels: true}

                const diagramDefinitionV = new DefinitionsDiagramV(core, $container, initialConfs, {
                    updateDiagram: (confs) => {diagramDefinitionV.show(diagramBuilder.build(defsWithFields, confs))}
                })

                const definitionsLoadLatch = new utils.CountdownLatch(visibleDefs.length, () => {
                    diagramDefinitionV.show(diagramBuilder.build(defsWithFields, initialConfs))
                });

                visibleDefs.forEach((def) => {
                    DefinitionM.get(core, def.getId(), {
                        forceReload: true,
                        success: function(definitionM) {
                            defsWithFields.push(definitionM.data)
                            definitionsLoadLatch.countDown("definition:loaded:" + def.getId());
                        }
                    });
                });
            },
            createDefinition: function() {
                core.navigateTo(UriBuilder.buildCreateDefinitionUri());
            },
            importDefinition: function() {
                uploadFileP.start('recordm/definitions');
            }
        }
    );

    var _getErrorMsgs = function(httpCode, responseText){
        var errors = [],
            responseErrors = {};

        if (httpCode === 400) {
            responseErrors = JSON.parse(responseText);

            errors = new FieldErrorM(core, responseErrors)
                .getTranslatedErrors()
                .map(function(e){
                    return "\"" + e.name + "\": " + (e.part ? `<code>${e.part}</code>:` : '') + e.errorMsg;
                });
        }

        if (errors.length === 0) {
            errors.push(core.translateString("recordm.domains", "definitions.import-errors.server-error")
                .replace("__HTTP__", httpCode));
        }

        return errors;
    };

    // Return the entity with this id from the collection
    var _getEntityMFrom = function(id, collection) {
        var _entityM;

        collection.some(function(entM) {
            if (entM.data.id === id) {
                _entityM = entM;
                return true;
            }
        });

        return _entityM;
    };

    // ##############################
    // Domain related functions
    // ##############################

    var _onDomainsLoaded = function(domainIds) {
        if (domainIds.length > 0) {
            _domainsM = [];

            const domainsLoadLatch = new utils.CountdownLatch(domainIds.length, function() {
                _filterDomains(_filter);
            });

            domainIds.forEach(function(domainId) {
                DomainM.get(core, domainId, {
                    success: function(domainM) {
                        _subscribeDomainM(domainM);
                        _domainsM.push(domainM);

                        domainsLoadLatch.countDown("domain:loaded:" + domainId);
                    }
                })
            });

        } else {
            domainsV.showDomainPlaceholder();
        }

        core.hideLoading(_loadingKey, "_domainsM.loadAll");
    };

    var _subscribeDomainM = function(domainM) {
        core.subscribe(domainM.update_event_name, _onDomainUpdated);
        core.subscribe(domainM.definition_added_event_name, _onDefinitionAddedToDomain);
        core.subscribe(domainM.definition_removed_event_name, _onDomainDefinitionRemoved);
        core.subscribe(domainM.delete_event_name, _onDomainDeleted);
    };

    var _unsubscribeDomain = function(domainM) {
        core.unsubscribe(domainM.update_event_name, _onDomainUpdated);
        core.unsubscribe(domainM.definition_added_event_name, _onDefinitionAddedToDomain);
        core.unsubscribe(domainM.definition_removed_event_name, _onDomainDefinitionRemoved);
        core.unsubscribe(domainM.delete_event_name, _onDomainDeleted);
    };

    var _onDomainCreated = function(e, data) {
        DomainM.get(core, data.id, {
            success: function(domainM) {
                _subscribeDomainM(domainM);
                _domainsM.push(domainM);

                domainsV.removeCreateDomainBlock(domainM.data);
                _filterDomains(_filter);

                core.updateAppInfo();
                core.hideLoading(_loadingKey, "_domainsM.domainCreated");
            }
        });
    };

    var _onDomainUpdated = function(e, domain) {
        domainsV.updateDomain(domain.id, domain);
        domainsV.removeEditDomainBlock(domain.id);

        _filterDomains(_filter);

        core.updateAppInfo();

        core.hideLoading(_loadingKey, "_domainsM.domainUpdated");
    };

    var _onDomainDeleted = function(e, data) {
        var domainId = data.id,
            domainM = _getEntityMFrom(domainId, _domainsM);

        _domainsM = _domainsM.filter(function(domainM) {
            return domainM.data.id !== domainId;
        });

        _unsubscribeDomain(domainM);

        domainsV.deleteDomain(data.id);

        if (_domainsM.length === 0) {
            domainsV.showDomainPlaceholder();
        }

        core.updateAppInfo();

        core.hideLoading(_loadingKey, "_domainsM.domainDeleted");
    };

    var _onDomainDefinitionRemoved = function(e, data) {
        domainsV.removeDefinitionFromDomain(data.id, data.definitionId);
        core.hideLoading(_loadingKey, "_domainsM.removeDefinitionFromDomain");
    };

    var _onDefinitionAddedToDomain = function(e, data) {
        domainsV.addDefinitionToDomain(data.id, _getEntityMFrom(data.definitionId, _definitionsM).data);
        core.hideLoading(_loadingKey, "_domainsM.addDefinitionToDomain");
    };

    // ##############################
    // Definitions related functions
    // ##############################

    const _onDefinitionsLoaded = function(definitionIds) {

        if (definitionIds.length > 0) {
            _definitionsM = [];

            const definitionsLoadLatch = new utils.CountdownLatch(definitionIds.length, function() {
                _filterDefinitions(_filter);
            });

            definitionIds.forEach(function(definitionId) {
                DefinitionM.get(core, definitionId, {
                    success: function(definitionM) {
                        _subscribeDefinitionM(definitionM);
                        _definitionsM.push(definitionM);

                        definitionsLoadLatch.countDown("definition:loaded:" + definitionId);
                    }
                });
            });

        } else {
            definitionsV.showDefinitionPlaceholder();
        }

        // filter is only useful if defs are loaded
        filterV.focus();

        core.hideLoading(_loadingKey, "_definitionM.loadAll");
    };

    var _subscribeDefinitionM = function(definitionM) {
        core.subscribe(definitionM.update_event_name, _onDefinitionUpdated);
        core.subscribe(definitionM.enable_event_name, _onDefinitionEnabled);
        core.subscribe(definitionM.disable_event_name, _onDefinitionDisabled);
        core.subscribe(definitionM.delete_event_name, _onDefinitionDeleted);
    };

    var _unsubscribeDefinitionM = function(definitionM) {
        core.unsubscribe(definitionM.update_event_name, _onDefinitionUpdated);
        core.unsubscribe(definitionM.enable_event_name, _onDefinitionEnabled);
        core.unsubscribe(definitionM.disable_event_name, _onDefinitionDisabled);
        core.unsubscribe(definitionM.delete_event_name, _onDefinitionDeleted);
    };

    // Get the previous definitionId in the array.
    // This is usefull to tell the view where to put the definition
    var _getPreviousDefinitionId = function(definitionId) {
        var i;

        if (_definitionsM.length === 1 || _definitionsM[0].data.id === definitionId) {
            return undefined;
        }

        for (i = 1; i < _definitionsM.length; i++) {
            if (_definitionsM[i].data.id === definitionId) {
                return _definitionsM[i - 1].data.id;
            }
        }

        return undefined;
    };

    var _onDefinitionAdded = function(e, data) {
        var definitionId = data.id;

        DefinitionM.get(core, definitionId, {
            success: function(definitionM) {
                _subscribeDefinitionM(definitionM);
                _definitionsM.push(definitionM);

                _filterDefinitions(_filter);

                core.hideLoading(_loadingKey, "_definitionM.definitionAdded");
            }
        });
    };

    var _onDefinitionUpdated = function(e, data) {
        var definitionId = data.id;

        DefinitionM.get(core, definitionId, {
            success: function(definitionM) {
                definitionsV.deleteDefinition(definitionM.data.id);
                definitionsV.addDefinition(definitionM, _getPreviousDefinitionId(definitionM.data.id));
                _filterDefinitions(_filter);

                domainsV.updateDefinitionName(data.id, data.name);
            }
        });
    };

    var _onDefinitionDisabled = function(e, data) {
        var definitionId = data.id;

        _definitionsM.sort(DefinitionM.sortByNameAndStateFn);

        definitionsV.deleteDefinition(definitionId);
        definitionsV.addDefinition(data.definitionM, _getPreviousDefinitionId(definitionId));

        core.hideLoading(_loadingKey, "_definitionM.disableDefinition");
    };

    var _onDefinitionEnabled = function(e, data) {
        var definitionId = data.id;

        definitionsV.deleteDefinition(definitionId);
        definitionsV.addDefinition(data.definitionM, _getPreviousDefinitionId(definitionId));
        _filterDefinitions(_filter);

        core.hideLoading(_loadingKey, "_definitionM.enableDefinition");
    };

    var _onDefinitionDeleted = function(e, data) {
        var definitionId = data.id,
            definitionM = _getEntityMFrom(definitionId, _definitionsM);

        _definitionsM = _definitionsM.filter(function(definitionM) {
            return definitionM.data.id !== definitionId;
        });

        _unsubscribeDefinitionM(definitionM);
        definitionsV.deleteDefinition(definitionId);

        if (_definitionsM.length === 0) {
            definitionsV.showDefinitionPlaceholder();
        }

        domainsV.removeDefinitionFromAllDomains(definitionId);

        core.hideLoading(_loadingKey, "_definitionM.deleteDefinition");
    };

    var _init = function(filterStr) {
        _filter = filterStr;
        filterV.init(filterStr);
        domainsV.init();
        definitionsV.init();

        core.showLoading(_loadingKey, "_definitionM.loadAll");
        DefinitionM.loadAll(core, _onDefinitionsLoaded);

        core.showLoading(_loadingKey, "_domainsM.loadAll");
        DomainM.loadAll(core, _onDomainsLoaded);

        core.subscribe(DomainM.created_event_name, _onDomainCreated);
        core.subscribe(DefinitionM.created_event_name, _onDefinitionAdded);
    };

    var _destroy = function() {
        core.unsubscribe(DomainM.created_event_name, _onDomainCreated);
        core.unsubscribe(DefinitionM.created_event_name, _onDefinitionAdded);

        _definitionsM.forEach(function(definitionM) {
            _unsubscribeDefinitionM(definitionM);
            definitionM.release();
        });

        _domainsM.forEach(function(domainM) {
            _unsubscribeDomain(domainM);
            domainM.release();
        });

        filterV.destroy();
        domainsV.destroy();
        definitionsV.destroy();
    };

    return {
        init: _init,
        pause: $.noop,
        resume: $.noop,
        destroy: _destroy
    };
};

export default DomainDefinitionsP;
